import { clsx, type ClassValue } from "clsx";
import { extendTailwindMerge } from "tailwind-merge";

// figma-tokens.css font sizes (text-figma-body-md-size, text-figma-font-size-16, …) aren't
// recognizable as sizes by name, so tailwind-merge would file them as colors and drop one
// of `text-figma-text-body-primary text-figma-body-md-size`.
const isFigmaFontSize = (value: string) =>
  /^figma-(.+-size|(typography-)?font-size(-\d+)?)$/.test(value);

// Teach tailwind-merge that the synced Figma radius tokens (rounded-figma-*, from
// figma-tokens.css) are border-radius classes, so they override a component's default radius
// instead of both classes surviving and CSS source order picking the winner.
const twMerge = extendTailwindMerge({
  extend: {
    theme: {
      radius: [(value: string) => value.startsWith("figma-")],
    },
    classGroups: { "font-size": [{ text: [isFigmaFontSize] }] },
  },
});

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
